import React from 'react'
import { Modal, Button, Table } from 'semantic-ui-react'
import SearchBar from './SearchBar'

const UnlinkedInvoicesModal = ({
  isUnlinkedInvoicesModalOpen,
  onUnlinkedInvoicesModalClose,
  unlinkedInvoices,
  unlinkedInvoicesSortConfig,
  onUnlinkedInvoicesSort,
  onUnlinkedInvoicesSearchPress,
}) => {
  return (
    <Modal
      open={isUnlinkedInvoicesModalOpen}
      onClose={onUnlinkedInvoicesModalClose}
      size="large"
    >
      <Modal.Header>Invoices Table</Modal.Header>
      <Modal.Content scrolling>
        <div style={{ marginBottom: '1rem' }}>
          <SearchBar
            onSearch={onUnlinkedInvoicesSearchPress}
          />
        </div>

        <Table sortable celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>
                <input type="checkbox" aria-label="Select all" />
              </Table.HeaderCell>
              <Table.HeaderCell
                sorted={unlinkedInvoicesSortConfig.key === 'orderNumber' ? (unlinkedInvoicesSortConfig.direction === 'asc' ? 'ascending' : 'descending') : null}
                onClick={() => onUnlinkedInvoicesSort('orderNumber')}
              >
                Invoice Code
              </Table.HeaderCell>
              <Table.HeaderCell
                sorted={unlinkedInvoicesSortConfig.key === 'enterpriseCode' ? (unlinkedInvoicesSortConfig.direction === 'asc' ? 'ascending' : 'descending') : null}
                onClick={() => onUnlinkedInvoicesSort('enterpriseCode')}
              >
                Enterprise Code
              </Table.HeaderCell>
              <Table.HeaderCell
                sorted={unlinkedInvoicesSortConfig.key === 'paymentDueDate' ? (unlinkedInvoicesSortConfig.direction === 'asc' ? 'ascending' : 'descending') : null}
                onClick={() => onUnlinkedInvoicesSort('paymentDueDate')}
              >
                Payment Due Date
              </Table.HeaderCell>
              <Table.HeaderCell
                sorted={unlinkedInvoicesSortConfig.key === 'amount' ? (unlinkedInvoicesSortConfig.direction === 'asc' ? 'ascending' : 'descending') : null}
                onClick={() => onUnlinkedInvoicesSort('amount')}
              >
                Invoice Amount
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {Array.isArray(unlinkedInvoices) && unlinkedInvoices.map((invoice, index) => {
              const {
                orderNumber = '',
                enterpriseCode = '',
                paymentDueDate = '',
                invoiceAmountString = '',
              } = invoice || {}

              return (
                <Table.Row key={orderNumber || index}>
                  <Table.Cell collapsing>
                    <input
                      type="checkbox"
                      aria-label={`Select invoice ${orderNumber}`}
                    />
                  </Table.Cell>
                  <Table.Cell>{orderNumber}</Table.Cell>
                  <Table.Cell>{enterpriseCode}</Table.Cell>
                  <Table.Cell>{paymentDueDate}</Table.Cell>
                  <Table.Cell>
                    {invoiceAmountString}
                  </Table.Cell>
                </Table.Row>
              )
            })}
          </Table.Body>
        </Table>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onUnlinkedInvoicesModalClose}>
          Fermer
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

export default UnlinkedInvoicesModal
